// Tweet length as X counts it (twitter-text v3 rules, mirrored by the API in
// apps/api/src/services/post-rules.ts): every link is 23 chars (t.co),
// emoji and CJK weigh 2, Latin text weighs 1.

// Bare domains (enflux.io, example.com/path) are links too: common gTLDs or
// any two-letter ccTLD. Erring toward counting a link keeps a near-limit tweet
// from passing here and then being rejected by X at publish time.
const X_URL_RE =
  /\b(?:https?:\/\/|www\.|[a-z0-9-]+(?:\.[a-z0-9-]+)*\.(?:com|net|org|io|co|ai|app|dev|me|ly|gg|tv|xyz|info|biz|shop|store|online|site|tech|news|blog|[a-z]{2})\b)[^\s]*?(?=[.,!?;:)\]'"]*(?:\s|$))/gi;
const X_LIGHT_RANGES: Array<[number, number]> = [
  [0, 4351],
  [8192, 8205],
  [8208, 8223],
  [8242, 8247],
];

export function xWeightedLength(text: string): number {
  let length = 0;
  const rest = text.normalize('NFC').replace(X_URL_RE, () => {
    length += 23;
    return '';
  });
  const clusters =
    typeof Intl.Segmenter === 'function'
      ? Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(rest), (s) => s.segment)
      : Array.from(rest);
  for (const g of clusters) {
    if (/\p{Extended_Pictographic}/u.test(g)) {
      length += 2;
      continue;
    }
    for (const ch of g) {
      const cp = ch.codePointAt(0) ?? 0;
      length += X_LIGHT_RANGES.some(([a, b]) => cp >= a && cp <= b) ? 1 : 2;
    }
  }
  return length;
}
